// created by AI

// created by AI: Keep popup sizing classes in a pure module so tests can verify
// long-name wrapping behavior without loading map/query side effects.
export const FACILITY_RADIUS_POPUP_CONTAINER_CLASS =
	"text-small -m-1 flex w-65 max-w-[70vw] flex-col items-start gap-1 text-left"

// created by AI: Text rows must use min-height, not fixed height, because facility
// names and types can wrap to multiple lines.
export const FACILITY_RADIUS_POPUP_TEXT_ROW_CLASS =
	"min-h-5 w-full leading-5 font-semibold break-words whitespace-normal"
